// src/beta/services/verification.ts
import { betaFetch } from '@/beta/services/api';
import type { V1Verification } from '@/beta/types/dossier';

interface Resp {
  version: 1;
  vehicle_id: string;
  data: V1Verification;
  generated_at: string;
}

export async function getVerification(vehicleId: string) {
  const res = await betaFetch<Resp>(`/vehicles/${vehicleId}/verification`);
  return res.data;
}
